import produce from "immer";
import { useState } from "react";
import { IGambit, IState } from "../../store/types";
import { ITabLabel } from "./types";

const tabs: ITabLabel[] = ["targets", "conditions", "actions"];

const makePick = (
  tab: ITabLabel,
  setTab: React.Dispatch<React.SetStateAction<ITabLabel>>,
  isReady: boolean,
  setGambit: React.Dispatch<React.SetStateAction<IGambit | undefined>>
) => (label: { key: string }) => {
  setGambit(
    produce(draft => {
      if (draft === undefined) return;
      if (tab === "targets") draft.target = label;
      else if (tab === "conditions") draft.condition = label;
      else draft.action = label;
    })
  );
  // TODO: only switch through tabs if a UI checkbox is selected
  if (!isReady && tab === "targets") setTab("conditions");
  else if (!isReady && tab === "conditions") setTab("actions");
};

const getPassedGambit = (state: IState) => {
  let passedGambit;
  if (state.pick.gambit) {
    const { index, actorIndex } = state.pick.gambit;
    passedGambit = state.actors[actorIndex].gambits[index];
  }
  return passedGambit;
};

export default function useSelection(state: IState) {
  const [tab, setTab] = useState<ITabLabel>("targets");
  const [gambit, setGambit] = useState<IGambit | undefined>(
    getPassedGambit(state)
  );

  const isReady = gambit !== undefined;
  const setPick = makePick(tab, setTab, !isReady, setGambit);

  // FIXME: clarify this casting and IChoice
  // https://github.com/microsoft/TypeScript/issues/33591
  let choices = state.bits[tab] as { key: string; enabled: boolean }[];
  choices = choices.filter(choice => choice.enabled);

  const tabProps = { tabs, setTab, tab, choices };
  const gambitProps = { gambit, isReady };
  return { tabProps, gambitProps, setPick };
}
